import IApiClient from "./ApiClient";
import {NewsLetterStatus, NewsLetterTermsModel, NewsLetterToggleRequest} from "models/NewsLetter"

export interface INewsLetterService {
  GetTerms() : Promise<NewsLetterTermsModel | undefined>
  GetStatus(): Promise<NewsLetterStatus | undefined>
  ToggleNewsLetter(toggle:boolean) : Promise<NewsLetterStatus | undefined>

}

export default class NewsLetterService implements INewsLetterService {
  apiBase: string;
  apiClient: IApiClient;

  constructor(apiClient: IApiClient) {
    this.apiBase = '/api/newsletter';
    this.apiClient = apiClient;
  }
   async GetTerms(): Promise<NewsLetterTermsModel | undefined> {
    
    
    try {
      const response = await this.apiClient.get<NewsLetterTermsModel>(
        `${this.apiBase}/terms`
      , false);
      return response ? response : undefined;
    } catch (exception) {
      console.error(exception);
    }
  }

  async GetStatus(): Promise<NewsLetterStatus | undefined> {
    
    try {
      const response = await this.apiClient.get<NewsLetterStatus>(
        `${this.apiBase}/status`
      ,false);
      return response ? response : undefined;
    } catch (exception) {
      console.error(exception);
    }
  }

  async ToggleNewsLetter(toggle: boolean): Promise<NewsLetterStatus | undefined> {
    try {
      const payload = { isChecked: toggle};
      const response = await this.apiClient.post<NewsLetterToggleRequest,NewsLetterStatus>(
        `${this.apiBase}/toggle`, payload);
      return response ? response : undefined;
    } catch (exception) {
      console.error(exception);
    }
  }
}